import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type {
  IModalContentProps,
  IModalOverlayProps,
  IModalTitleProps,
} from './IModalProps';

const Modal = Dialog.Root;
const ModalTrigger = Dialog.Trigger;
const ModalClose = Dialog.Close;

const ModalOverlay = forwardRef<HTMLDivElement, IModalOverlayProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;
    return (
      <Dialog.Overlay
        className={twMerge(
          'bg-black opacity-50 z-40 fixed inset-0 data-[state=open]:animate-overlayShow',
          className
        )}
        ref={forwardedRef}
        {...rest}
      />
    );
  }
);

ModalOverlay.displayName = 'ModalOverlay';

const ModalPortal = Dialog.Portal;

const ModalTitle = forwardRef<HTMLHeadingElement, IModalTitleProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;
    return (
      <Dialog.Title
        className={twMerge(
          'font-chromatica text-[32px] font-black text-retail-text-primary',
          className
        )}
        {...rest}
        ref={forwardedRef}
      />
    );
  }
);

ModalTitle.displayName = 'ModalTitle';

const ModalDescription = forwardRef<HTMLParagraphElement, IModalTitleProps>(
  (props, forwardedRef) => {
    return <Dialog.Description {...props} ref={forwardedRef} />;
  }
);

ModalDescription.displayName = 'ModalDescription';

const ModalContent = forwardRef<HTMLDivElement, IModalContentProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;
    return (
      <Dialog.Content
        className={twMerge(
          'bg-white z-50 px-10 pt-10 pb-8 border border-retail-gray-100 rounded-3xl fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]',
          className
        )}
        {...rest}
        ref={forwardedRef}
      />
    );
  }
);

ModalContent.displayName = 'ModalContent';

export {
  Modal,
  ModalClose,
  ModalContent,
  ModalDescription,
  ModalOverlay,
  ModalPortal,
  ModalTitle,
  ModalTrigger,
};
